import React from 'react';
import Modal from '../utils/Modal/Modal';

const AlertDialog = ({
  show,
  onClose,
  title = 'Alert',
  message,
  confirmLabel = 'OK',
  confirmColor = '#451a03',
  showCancel = false,
  cancelLabel = 'Cancel',
  onConfirm = null,
}) => {
  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    onClose();
  };

  return (
    <Modal
      show={show}
      onClose={onClose}
      title={title}
      size="dialog"
      showActions={true}
      confirmLabel={confirmLabel}
      confirmColor={confirmColor}
      cancelLabel={showCancel ? cancelLabel : null}
      onConfirm={handleConfirm}
    >
      <div style={{ marginBottom: 24 }}>{message}</div>
    </Modal>
  );
};

export default AlertDialog;
